var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hv-opener" }, [
    _c(
      "div",
      {
        ref: "questionModal",
        staticClass: "modal fade",
        attrs: {
          id: "questionmodal" + _vm.questionId,
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "questionmodal" + _vm.questionId,
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "div",
                  { staticClass: "t3", staticStyle: { color: "#c00" } },
                  [_vm._v(_vm._s(_vm.getTrans("HeaderName")))]
                ),
                _vm._v(" "),
                _vm._m(0),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("p", [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.getTrans("BodyText1")) +
                          "\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.getTrans("BodyContactInformation")) +
                          "\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.getTrans("BodyText2")) +
                          "\n                            "
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("form", [
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          { attrs: { for: "inputArticleId" + _vm.questionId } },
                          [_vm._v(_vm._s(_vm.getTrans("FormNameArtikelID")))]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "inputArticleId" + _vm.questionId,
                            placeholder: _vm.getTrans("FormNameArtikelID"),
                            readonly: "",
                          },
                          domProps: { value: _vm.itemId },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          {
                            attrs: {
                              for: "inputArticleNumber" + _vm.questionId,
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.getTrans("FormNameArtikelnummer"))
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "inputArticleNumber" + _vm.questionId,
                            placeholder: _vm.getTrans("FormNameArtikelnummer"),
                            readonly: "",
                          },
                          domProps: { value: _vm.variationNumber },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          { attrs: { for: "inputName" + _vm.questionId } },
                          [_vm._v(_vm._s(_vm.getTrans("FormNameName")))]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputName,
                              expression: "inputName",
                            },
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid":
                              _vm.inputName && _vm.inputName.length == 0,
                          },
                          attrs: {
                            type: "text",
                            id: "inputName" + _vm.questionId,
                            placeholder: _vm.getTrans("FormLabelName"),
                          },
                          domProps: { value: _vm.inputName },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.inputName = $event.target.value
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _vm.questionId == 1
                        ? _c("div", { staticClass: "form-group" }, [
                            _c(
                              "label",
                              {
                                attrs: { for: "currentprice" + _vm.questionId },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.getTrans("FormNameAktuellerPreis"))
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "currentprice" + _vm.questionId,
                                readonly: "",
                              },
                              domProps: { value: _vm.defaultPrice },
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.questionId == 1
                        ? _c("div", { staticClass: "form-group" }, [
                            _c(
                              "label",
                              { attrs: { for: "inputPrice" + _vm.questionId } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.getTrans("FormNameIhrePreisanfrage")
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.inputPrice,
                                  expression: "inputPrice",
                                },
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid":
                                  _vm.inputPrice && _vm.inputPrice.length == 0,
                              },
                              attrs: {
                                type: "text",
                                id: "inputPrice" + _vm.questionId,
                                placeholder: _vm.getTrans(
                                  "FormLabelIhrePreisanfrage"
                                ),
                              },
                              domProps: { value: _vm.inputPrice },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.inputPrice = $event.target.value
                                },
                              },
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          { attrs: { for: "inputEmail" + _vm.questionId } },
                          [_vm._v(_vm._s(_vm.getTrans("FormNameEmailAdresse")))]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputEmail,
                              expression: "inputEmail",
                            },
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid":
                              _vm.inputEmail && _vm.inputEmail.length == 0,
                          },
                          attrs: {
                            type: "email",
                            id: "inputEmail" + _vm.questionId,
                            "aria-describedby": "emailHelp",
                            placeholder: _vm.getTrans("FormLabelEmailAdresse"),
                          },
                          domProps: { value: _vm.inputEmail },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.inputEmail = $event.target.value
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          { attrs: { for: "inputComment" + _vm.questionId } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.questionId == 1
                                  ? _vm.getTrans("FormNameComment")
                                  : _vm.getTrans("FormIhreFrage")
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputComment,
                              expression: "inputComment",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            id: "inputComment" + _vm.questionId,
                            placeholder:
                              _vm.questionId == 1
                                ? _vm.getTrans("FormLabelComment")
                                : _vm.getTrans("FormLabelIhreFrage"),
                            height: "400px",
                          },
                          domProps: { value: _vm.inputComment },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.inputComment = $event.target.value
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          type: "hidden",
                          id: "referrerId" + _vm.questionId,
                          name: "referrerId",
                        },
                        domProps: { value: _vm.referrerId },
                      }),
                      _vm._v(" "),
                      !_vm.isOnSending
                        ? _c("input", {
                            staticClass: "btn btn-primary",
                            attrs: {
                              type: "button",
                              id: "sendNewPrice" + _vm.questionId,
                              value: _vm.getTrans("FormSubmitButton"),
                            },
                            on: { click: _vm.sendPrice },
                          })
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.isAlertOpen
                      ? _c(
                          "div",
                          {
                            staticClass: "alert alert-success mt-2",
                            attrs: {
                              id: "question-alert" + _vm.questionId,
                              role: "alert",
                            },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.getTrans("FormSuccessAlert")) +
                                "\n                            "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }